module.exports = __webpack_public_path__ + "img/sample_Headshot.df0b85a5.png";